import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import MoviesGrid from "@/component/commom/movies-grid";
import Footer from "@/component/footer";
import Header from "@/component/header";
import { SearchParams, SearchSort } from "@/entry/local/movie";
import { SearchResult } from "@/entry/server/movie";
import { Pagination } from "@/lib/api";
import { videoRepo } from "@/repo/video-repo";
import { useQueryParams, getQueryParam } from "@/hooks/useQueryParams";
import NotFound from "@/pages-app/not-found";

export default function NetworkPage() {
    const routeParams = useParams<{ slug: string }>();
    const queryParams = useQueryParams();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);
    const [searchResult, setSearchResult] = useState<SearchResult | null>(null);
    const [pagination, setPagination] = useState<Pagination | null>(null);
    const [searchParamsObject, setSearchParamsObject] = useState<SearchParams | null>(null);
    const [pageTitle, setPageTitle] = useState("");

    useEffect(function () {
        var slug = routeParams.slug;
        if (!slug) {
            setNotFound(true);
            setLoading(false);
            return;
        }

        setLoading(true);
        setNotFound(false);
        var imdbRate = getQueryParam(queryParams, "imdb_rate", "0");
        var isDubbed = getQueryParam(queryParams, "is_dubbed", "");
        var isSubbed = getQueryParam(queryParams, "is_subbed", "");
        var genre = getQueryParam(queryParams, "genre", "0");
        var sort = getQueryParam(queryParams, "sort", "");
        var page = getQueryParam(queryParams, "page", "1");
        var title = getQueryParam(queryParams, "title", "");

        videoRepo.getTaxonomyInfo("network", slug).then(function (taxonomyInfo) {
            if (!taxonomyInfo.status || !taxonomyInfo.data) {
                setNotFound(true);
                setLoading(false);
                return;
            }

            var paramsObject: SearchParams = {
                network: taxonomyInfo.data.id,
                imdb_rate: parseFloat(imdbRate),
                is_dubbed: isDubbed === "true",
                is_subbed: isSubbed === "true",
                genre: parseInt(genre, 10),
                sort: sort as SearchSort,
                page: parseInt(page, 10),
            };

            videoRepo.search(paramsObject).then(function (result) {
                var resolvedTitle = title;
                if (!resolvedTitle) {
                    resolvedTitle = "شبکه پخش " + taxonomyInfo.data!.name;
                }
                if (result.data) {
                    setSearchResult(result.data);
                }
                if (result.pagination) {
                    setPagination(result.pagination);
                }
                setSearchParamsObject(paramsObject);
                setPageTitle(resolvedTitle);
                setLoading(false);
            });
        });
    }, [routeParams.slug, location.search]);

    if (notFound) {
        return <NotFound />;
    }

    if (loading || !searchResult || !pagination || !searchParamsObject) {
        return (
            <div className="page-loading">
                <div className="loader" />
            </div>
        );
    }

    return (
        <>
            <Header />
            <MoviesGrid
                defaultSearchResult={searchResult}
                defaultPagination={pagination}
                title={pageTitle}
                defaultSearchParams={searchParamsObject} />
            <Footer />
        </>
    );
}
